import { render, staticRenderFns } from "./companyInfo.vue?vue&type=template&id=7a7a496b&scoped=true"
import script from "./companyInfo.vue?vue&type=script&lang=js"
export * from "./companyInfo.vue?vue&type=script&lang=js"
import style0 from "./companyInfo.vue?vue&type=style&index=0&id=7a7a496b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7a496b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a7a496b')) {
      api.createRecord('7a7a496b', component.options)
    } else {
      api.reload('7a7a496b', component.options)
    }
    module.hot.accept("./companyInfo.vue?vue&type=template&id=7a7a496b&scoped=true", function () {
      api.rerender('7a7a496b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auditcenter/components/companyInfo.vue"
export default component.exports